{
  "CHAT_LIST": {
    "LOADING": "Preuzimanje razgovora",
    "LOAD_MORE_CONVERSATIONS": "Učitaj više razgovora",
    "EOF": "Svi razgovori su učitani 🎉",
    "LIST": {
      "404": "Ne postoje aktivni razgovori u ovoj grupi."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Razgovori",
    "MENTION_HEADING": "Spominjanja",
    "UNATTENDED_HEADING": "Nedodeljeni",
    "SEARCH": {
      "INPUT": "Tražite osobe, razgovore, gotove odgovore .."
    },
    "SEARCH_MESSAGES": "Pretraži razgovore",
    "SEARCH_INPUT_PLACEHOLDER": "Pretraži razgovore...",
    "FILTER_ALL": "Sve",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Moji",
      "unassigned": "Nedodeljen",
      "all": "Sve"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Nalepi u odgovor",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Otvori",
        "BUY": "Kupi"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Otvoreni"
      },
      "resolved": {
        "TEXT": "Rešeni"
      },
      "pending": {
        "TEXT": "Nerešen"
      },
      "snoozed": {
        "TEXT": "Odložen"
      },
      "all": {
        "TEXT": "Sve"
      }
    },
    "VIEW_FILTER": "Pregled",
    "SORT_TOOLTIP_LABEL": "Sortiraj razgovore",
    "CHAT_SORT": {
      "STATUS": "Status",
      "ORDER_BY": "Sortiraj po"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Kreirano",
      "LAST_ACTIVITY": "Poslednja aktivnost:",
      "LAST_CUSTOMER_MESSAGE": "Poslednja poruka klijenta:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Poslednja poruka klijenta: Prvo najstarije"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Poslednja poruka klijenta: Prvo najnovije"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Prioritet + Vreme kreiranja: Prvo najnovije"
      },
      "priority_created_at_asc": {
        "TEXT": "Prioritet + Vreme kreiranja: Prvo najstarije"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Slikovita poruka"
      },
      "audio": {
        "CONTENT": "Govorna poruka"
      },
      "video": {
        "CONTENT": "Video poruka"
      },
      "file": {
        "CONTENT": "Prilog"
      },
      "location": {
        "CONTENT": "Lokacija"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "je podelio link"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sortirajte prema",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Poslednja aktivnost"
        },
        "CREATED_AT": {
          "NAME": "Napravljena u",
          "LABEL": "Napravljena u"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Primljeno putem e-maila",
    "VIEW_TWEET_IN_TWITTER": "Pogledaj tweet na Twitteru",
    "REPLY_TO_TWEET": "Odgovori na tweet",
    "LINK_TO_STORY": "Idi na instagram priču",
    "SENT": "Uspešno poslano",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Nema poruka",
    "NO_CONTENT": "Nema sadržaja",
    "HIDE_QUOTED_TEXT": "Sakriji citirani tekst",
    "SHOW_QUOTED_TEXT": "Prikaži citirani tekst",
    "HIDE_AUTOMATED_MESSAGE": "Sakrij sadržaj automatskog odgovora",
    "SHOW_AUTOMATED_MESSAGE": "Prikaži sadržaj automatskog odgovora",
    "AUTOMATED_MESSAGE": "Automatski odgovor",
    "MESSAGE_READ": "Pročitane",
    "SENDING": "Sending"
  }
}
